import './assets/sass/app.scss'

const $ = require('jquery')
window.$ = $

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

import Api from './api'
import {VueTrans} from './translations'

// bootstrap
import 'bootstrap'

// slick
import slick from 'slick-carousel'
global.slick = slick

Vue.use(VueTrans)

Vue.prototype.$api = Api
Vue.prototype.$http = axios

Vue.config.productionTip = false

if(typeof window.dataLayer === 'undefined') window.dataLayer = [];

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

$(() => {
  console.log('%c With ❤️ from Netcore ', 'background: #222; color: #fff')
})
